import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';

import {
  generateCustomIndexFn,
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { MainQuery } from '@shared/store/main/main.query';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, RouteTabGroupComponent, AsyncPipe],
  selector: 'aux-site-costs',
  styleUrl: './site-costs.component.scss',
  templateUrl: './site-costs.component.html',
})
export class SiteCostsComponent {
  private readonly launchDarklyService = inject(LaunchDarklyService);
  private readonly mainQuery = inject(MainQuery);
  private readonly router = inject(Router);

  indexFn = generateCustomIndexFn(
    `${ROUTING_PATH.INVESTIGATOR.INDEX}/${ROUTING_PATH.INVESTIGATOR.SITE_COSTS.INDEX}`
  );
  isFullPage$ = this.mainQuery.select('fullPage');
  tabs: TabGroupConfig[] = [
    {
      label: 'Sites',
      route: ROUTING_PATH.INVESTIGATOR.SITE_COSTS.SITES.INDEX,
      show: toObservable(this.launchDarklyService.$select((flags) => flags.tab_investigator_sites)),
    },
    {
      label: 'Site Cost Summary',
      route: ROUTING_PATH.INVESTIGATOR.SITE_COSTS.SITE_COST_SUMMARY,
      show: toObservable(
        this.launchDarklyService.$select((flags) => flags.tab_trial_settings_patient_protocol)
      ),
    },
  ];

  get isSiteInfo(): boolean {
    return (
      this.router.url.includes(`/${ROUTING_PATH.INVESTIGATOR.SITE_COSTS.SITES.DETAILS}`) ||
      this.router.url.includes(`/${ROUTING_PATH.INVESTIGATOR.SITE_COSTS.SITES.COSTS}`)
    );
  }
}
